import styled from "styled-components";
import { IconButton } from "@material-ui/core";

const TemplateAction = styled(IconButton)`
  border-radius: 6px;
  min-width: 50px;
  padding: 6px 4px;
  margin: 0 2px;

  .MuiIconButton-label {
    flex-direction: column;
  }

  svg {
    height: 15px;
  }

  .action-label {
    color: #08091f;
    font-size: 0.7rem;
    padding-top: 2px;
    text-align: center;
  }
`;

export default TemplateAction;
